var _linearGradient, _linearGradient2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconHomeAddress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 45,
    viewBox: "0 0 512 512",
    width: 45,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    x2: 256,
    y1: 512,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5558ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00c0ff"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    x2: 256,
    y1: 270,
    y2: 90.001
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#addcff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    stopColor: "#eaf6ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#eaf6ff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m256 0c-99.258 0-180 80.742-180 180 0 30.308 7.676 60.293 22.588 87.305l144.639 237.547c2.724 4.438 7.558 7.148 12.773 7.148s10.049-2.71 12.773-7.148l145.02-238.162c14.531-26.397 22.207-56.382 22.207-86.69 0-99.258-80.742-180-180-180z",
    fill: "url(#SVGID_1_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m356.499 184.501-90-90c-5.7-6-15.299-6-20.999 0l-90 90c-6 5.7-6 15.298 0 20.999 5.398 6.002 15.603 6 20.999 0l4.501-4.199v53.699c0 8.401 6.599 15 15 15h45v-45c0-8.401 6.599-15 15-15s15 6.599 15 15v45h45c8.401 0 15-6.599 15-15v-53.699l4.501 4.199c5.398 6.002 15.603 6 20.999 0 6-5.701 6-15.299-.001-20.999z",
    fill: "url(#SVGID_2_)"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHomeAddress);
export default __webpack_public_path__ + "static/media/iconHomeAddress.71f74e405fb47164bc8c57de6ae85a33.svg";
export { ForwardRef as ReactComponent };